<style lang="scss" scoped>
@import './../assets/sass/colors';

footer {
  padding-bottom: 2vh;

  a.subtitle {
    color: $accent-primary-color;
  }

  a.social-circle {
    background-color: #5d5d5d26;
  }

  li {
    display: inline;
    margin-right: 5px;
  }

  p {
    margin-bottom: 10px;
  }
}
.container {
  padding-top: 30px;
}
.subscribe-panel {
  padding: 12px;
  background: #5e0100;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column wrap;
  text-align: center;
}
.subscribe-btn {
  background: #c3041c;
  font-size: 17px;
  text-transform: capitalize;
  padding: 10px 37px;
  height: auto;
  border-radius: 45px;
}
</style>

<template lang="pug">
footer
  app-newsletter-form(v-if='showModal', v-on:close='showModal = false')
  .subscribe-panel(v-if='!user')
    div
      p.title.white-text.small Subscribe to our newsletter to get updates and amazing offers delivered directly in your inbox.
    div
      button.btn.subscribe-btn(@click='openModal(user)') Subscribe Now!
  v-container
    v-row
      v-col(cols='12', sm='6', md='4')
        .subtitle.alternate.small Contact Us
        .vspace.medium
        p
          i.material-icons.left phone_iphone
          span +63 917 318 0286
        p
          i.material-icons.left email
          span admin@inom.ph
        // p
          router-link Work with us

      v-col(cols='12', sm='6', md='4')
        p.subtitle.alternate.small Follow Us
        ul
          li
            a.social-circle.icoFacebook(
              href='https://www.facebook.com/InomPhOfficial/',
              target='_blank',
              title='Facebook'
            )
              i.fa.fa-facebook
            span.white-text
          li
            a.social-circle.icoTwitter(href='#', title='Twitter')
              i.fa.fa-twitter
            span.white-text
          li
            a.social-circle.icoGoogle(
              href='mailto:admin@inom.ph',
              title='Google +'
            )
              i.fa.fa-google-plus
            span.white-text
          li
            a.social-circle.icoInstagram(href='#', title='Instagram')
              i.fa.fa-instagram
            span.white-text

        //- .vspace.medium
        //- router-link.subtitle.alternate.small(:to="{path: '/partner-with-us'}") Become our Partner

      //- .col.l3.s6.offset-s3.m6.offset-m3.offset-l0
      v-col(cols='12', sm='6', md='3')
        img.responsive-img(src='./../assets/img/inomph_logo_md.png')
</template>
<script>
import axios from 'axios'
import AppNewsletterForm from '@/components/app-newsletter-form'

export default {
  data() {
    return {
      isSubscribe: null,
      email: null,
      showModal: false,
    }
  },
  created() {
    // this.isAlredySubs();
  },
  computed: {
    user() {
      return this.$store.state.customer.isSubscribeNewsletter
    },
  },
  methods: {
    isAlredySubs() {
      if (this.user !== null) {
        axios
          .get(
            `${this.$config.API_URL}/newsletter/sib-check-subscriber-exist/${this.user.email}`
          )
          .then((res) => {
            this.isSubscribe = res.data
          })
      } else {
        this.isSubscribe = false
      }
    },
    openModal(isSubscribe) {
      this.showModal = true
      // const modalParams = {
      //   content: AppNewsletterForm,
      //   style: { fullscreen: false, padding: 'medium' },
      //   bind: {
      //     order: isSubscribe
      //   }
      // }

      // this.$store.dispatch('modal/open', modalParams)
    },
  },
  components: {
    AppNewsletterForm,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/app-footer.vue